import Button from "@mlb/react-patterns/dist/components/Button/button";
import { Label } from "@mlb/react-patterns/dist/components/Button/button.style";
import { ButtonShapes, ButtonSizes, ButtonStyles } from "@mlb/react-patterns/dist/components/Button/button.types";
import COLORS from "@mlb/react-patterns/dist/style/universal.color";
import styled from "styled-components";
import DragHandle from "../DragHandle";
export var REMOVE_BUTTON_WIDTH = "108px";
export var ManageFollowRowContainer = styled.li.withConfig({
  displayName: "styles__ManageFollowRowContainer",
  componentId: "sc-1opgn-0"
})(["overflow-x:hidden;position:relative;"]);
export var ManageFollowRowInnerContainer = styled.div.withConfig({
  displayName: "styles__ManageFollowRowInnerContainer",
  componentId: "sc-1opgn-1"
})(["align-items:center;background:", ";display:flex;height:100%;position:relative;z-index:1;"], COLORS.mlbWhite);
export var ManageFollowRowDeleteButton = styled(Button).attrs({
  shape: ButtonShapes.HOLLOW_BORDERLESS,
  size: ButtonSizes.LARGE,
  styleName: ButtonStyles.GREY
}).withConfig({
  displayName: "styles__ManageFollowRowDeleteButton",
  componentId: "sc-1opgn-2"
})(["background:#d10026;border-radius:50%;height:22px;margin-right:11px;padding:0;position:relative;width:22px;&:after{border-radius:5px;border:1px solid white;content:\"\";left:5px;position:absolute;right:5px;top:calc(50% - 1px);}&[data-focus-visible-added]{box-shadow:0 0 0 3px rgba(0,137,255,0.65);outline:none;}&:hover{background:rgba(209,0,38,0.85);}"]);
export var ManageFollowRowDragHandle = styled(DragHandle).withConfig({
  displayName: "styles__ManageFollowRowDragHandle",
  componentId: "sc-1opgn-3"
})(["align-self:stretch;height:auto;margin-left:auto;position:relative;"]);
export var ManageFollowRowRemoveContainer = styled.div.withConfig({
  displayName: "styles__ManageFollowRowRemoveContainer",
  componentId: "sc-1opgn-4"
})(["height:100%;left:0;position:absolute;text-align:right;top:0;width:100%;transition-delay:300ms;", ""], function (_ref) {
  var showRemove = _ref.showRemove;
  return showRemove && "\n      background:#d10026;\n      transition-delay:0s;\n    ";
});
export var ManageFollowRowRemoveButton = styled(Button).attrs({
  shape: ButtonShapes.DEFAULT,
  size: ButtonSizes.MEDIUM,
  styleName: ButtonStyles.GREY
}).withConfig({
  displayName: "styles__ManageFollowRowRemoveButton",
  componentId: "sc-1opgn-5"
})(["background:inherit;border-radius:0;height:inherit;width:", ";&.focus-visible{box-shadow:inset 0 0 0 3px rgba(0,137,255,0.65);outline:none;}&:hover{background:rgba(255,255,255,0.15);color:", ";}", "{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%;}"], REMOVE_BUTTON_WIDTH, COLORS.mlbWhite, Label);